import { motion, ursaColors } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";
import { buttonPrimary, neutralAccessible, neutralDark30, neutralDark40, neutralLight20, toRgba } from "../../constants/colors";
import { sizes } from "../../constants/spacing";
export var tabsTheme = themed({
  canvas: {
    textColor: {
      "lodestar-light": neutralDark30,
      "ursa-light": ursaColors.slate800
    },
    underlineColor: {
      "lodestar-light": neutralLight20,
      "ursa-light": ursaColors.slate50
    },
    underlineHoverColor: {
      "lodestar-light": neutralAccessible,
      "ursa-light": ursaColors.slate75
    }
  },
  "work-surface": {
    textColor: {
      "lodestar-light": neutralDark30,
      "ursa-light": ursaColors.neutral800
    },
    underlineColor: {
      "lodestar-light": neutralLight20,
      "ursa-light": ursaColors.neutral50
    },
    underlineHoverColor: {
      "lodestar-light": neutralAccessible,
      "ursa-light": ursaColors.neutral75
    }
  },
  selectedTextColor: {
    "lodestar-light": neutralDark40,
    "ursa-light": ursaColors.blue600
  },
  disabledTextColor: {
    "lodestar-light": toRgba(neutralDark30, 0.4),
    "ursa-light": ursaColors.neutral300
  },
  underlineHeight: {
    default: {
      "lodestar-light": "2px",
      "ursa-light": "1px"
    },
    active: {
      "lodestar-light": "2px",
      "ursa-light": "3px"
    }
  },
  underlineSelectedColor: {
    "lodestar-light": buttonPrimary,
    oldestar: "#0073EC",
    "ursa-light": ursaColors.blue600
  },
  underlineAnimation: {
    "lodestar-light": "",
    "ursa-light": motion.easing.default
  },
  font: {
    weight: {
      "lodestar-light": "600",
      "ursa-light": "500"
    },
    lineHeight: "18px"
  },
  containerHeight: {
    "lodestar-light": "".concat(sizes.large, "px"),
    "ursa-light": "36px"
  },
  focusRingRadius: {
    "lodestar-light": "4px",
    "ursa-light": 0
  },
  focusRingGap: {
    "lodestar-light": 2,
    "ursa-light": 8
  },
  focusRingRadiusOverride: {
    "lodestar-light": "0",
    "ursa-light": "8px"
  },
  focusRingInsetOverride: {
    "lodestar-light": "",
    "ursa-light": "0px"
  },
  tabMarginLeft: {
    "lodestar-light": "".concat(sizes.xLarge, "px"),
    "ursa-light": "".concat(sizes.large, "px")
  }
});
//# sourceMappingURL=tabsTheme.js.map